// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.back-button {
  margin-bottom: 1.5rem;
  cursor: pointer;
  color: #0066b2;
  border-color: #0066b2;
  background-color: #fff;
  border-radius: 5px;
}

.release-details {
  margin-top: 16px;
}

.release-detail-tabs {
  margin-top: 8px;
}

:host ::ng-deep .release-detail-tabs .mat-mdc-tab-header {
  margin-bottom: 50px;
}

.release-summary {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}
.release-summary .header-meta-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.release-summary .title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.release-summary .title-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.release-summary .title-left h2 {
  margin: 0;
  color: #0b2d71;
  font-size: 30px;
  line-height: 1.1;
}
.release-summary .release-count {
  color: #0b2d71;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 22px;
  font-style: italic;
}

.header-business-unit,
.header-spec-id {
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 16px;
}

.header-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.status-badge {
  background-color: #0066b2;
  color: white;
  padding: 6px 12px;
  border-radius: 14px;
  font-size: 13px;
  font-family: "GothamBold", Arial, sans-serif;
}
.status-badge.status-draft {
  background-color: #751569;
}
.status-badge.status-in-review {
  background-color: #5cc0e7;
}
.status-badge.status-ready-to-publish {
  background-color: #0066b2;
}
.status-badge.status-published {
  background-color: #3a9e5f;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 8px 20px;
}

.content-layout {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.filters-column {
  width: 280px;
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.filter-header h6 {
  margin: 0;
  color: #0b2d71;
}

.clear-all-btn {
  border: none;
  background-color: white;
  color: #0066b2;
  cursor: pointer;
}

.table-column {
  flex: 1;
}

.table-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 14px;
}

.search-input-wrapper {
  flex: 1;
}

.bulk-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  white-space: nowrap;
}

.bulk-status-field {
  width: 180px;
}

:host ::ng-deep .bulk-status-field .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

:host ::ng-deep .bulk-status-field .mat-mdc-text-field-wrapper {
  background: white;
}

:host ::ng-deep .bulk-status-field .mat-mdc-form-field-flex {
  align-items: center;
}

:host ::ng-deep .bulk-status-field .mat-mdc-select-trigger {
  min-height: 20px;
}

:host ::ng-deep .bulk-status-field .mat-mdc-select-arrow {
  color: #0066b2;
}

:host ::ng-deep .bulk-status-field .mat-mdc-select-placeholder,
:host ::ng-deep .bulk-status-field .mat-mdc-select-value-text {
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
}

.bulk-remove-btn {
  border: 1px solid #e3e3e3;
  background: white;
  color: #97002e;
  width: 40px;
  min-width: 40px;
  height: 40px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.bulk-remove-btn[disabled] {
  color: #8c8f93;
  cursor: not-allowed;
}

.esra-outline-btn {
  border: 1px solid #0066b2;
  background: white;
  color: #0066b2;
  padding: 6px 10px;
  font-size: 13px;
  cursor: pointer;
}

.esra-primary-btn {
  border: none;
  background-color: #0066b2;
  color: white;
  padding: 6px 14px;
  font-size: 13px;
  cursor: pointer;
  font-family: "Gotham", Arial, sans-serif;
}
.esra-primary-btn[disabled] {
  background-color: #9e9e9e;
  opacity: 0.6;
  cursor: not-allowed;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}

.table-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.table-top-bar .selected-count {
  color: #0b2d71;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
}

.add-class-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: none;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}

.release-specs-table {
  width: 100%;
  border: 1px solid #e3e3e3;
}

.release-specs-table .spec-link,
.release-specs-table .spec-link:link,
.release-specs-table .spec-link:visited {
  color: #0066b2 !important;
  cursor: pointer;
  text-decoration: none;
}

.release-specs-table .spec-link:hover,
.release-specs-table .spec-link:focus {
  color: #0066b2 !important;
  text-decoration: underline;
}

.info-dropdown-placeholder {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: none;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}

.info-cell {
  width: 80px;
  text-align: center;
}

.info-cell-content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.comment-slot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-right: 6px;
  flex: 0 0 auto;
}

.comment-indicator {
  color: #0066b2;
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
}

.info-dropdown-placeholder .icon {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.info-dropdown-placeholder .icon.chevron-up {
  transform: rotate(180deg);
}

tr.detail-row td.mat-mdc-cell,
tr.detail-row td.mat-cell {
  padding: 0;
  border-bottom: none;
}

.expanded-detail-cell {
  padding: 0 !important;
}

.info-comment-content {
  font-size: 13px;
  color: #333;
  line-height: 1.4;
}

.info-no-comments {
  font-size: 13px;
  color: #8c8f93;
  margin: 4px 0;
}

.empty-state-message {
  border: 1px solid #e3e3e3;
  background-color: #f7f7f7;
  color: #707070;
  padding: 14px;
  font-family: "Gotham", Arial, sans-serif;
}

.mat-mdc-header-cell {
  font-family: "GothamBold", Arial, sans-serif;
}

:host ::ng-deep .release-specs-table tr.mat-mdc-row:not(.detail-row),
:host ::ng-deep .release-specs-table tr.mat-mdc-header-row {
  height: 40px;
}
:host ::ng-deep .release-specs-table tr.detail-row {
  height: 0;
}
:host ::ng-deep .release-specs-table th.mat-mdc-header-cell.mat-column-select,
:host ::ng-deep .release-specs-table td.mat-mdc-cell.mat-column-select {
  padding-left: 4px;
  padding-right: 8px;
}
:host ::ng-deep .release-specs-table th.mat-mdc-header-cell.mat-column-select .mat-mdc-checkbox,
:host ::ng-deep .release-specs-table td.mat-mdc-cell.mat-column-select .mat-mdc-checkbox {
  margin: 0;
}
:host ::ng-deep .release-specs-table tr.mat-mdc-row:not(.detail-row):nth-child(4n+1) td.mat-mdc-cell {
  background-color: white;
}
:host ::ng-deep .release-specs-table tr.mat-mdc-row:not(.detail-row):nth-child(4n+3) td.mat-mdc-cell {
  background-color: #e3e3e3;
}

@media (max-width: 1100px) {
  .content-layout {
    flex-direction: column;
  }
  .filters-column {
    width: 100%;
  }
  .summary-grid {
    grid-template-columns: 1fr;
  }
  .table-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .bulk-actions {
    flex-wrap: wrap;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
